import gql from 'graphql-tag';
import { scheduledSessionParticipantEntryFieldsFragment } from '../fragments';

export const overrideScheduledSessionParticipantEntryMutation = gql`
  mutation OverrideScheduledSessionParticipantEntry($scheduledSessionId: ID!, $participantId: ID!, $override: ScheduledSessionParticipantEntryOverrideInput!) {
    overrideScheduledSessionParticipantEntry(scheduledSessionId: $scheduledSessionId, participantId: $participantId, override: $override) {
      ...AdminScheduledSessionParticipantEntryFields
    }
  }

  ${scheduledSessionParticipantEntryFieldsFragment}
`;